// Only used to schedule renewal. Token validation remains on the server.
function decode(token: unknown): any {
  if (typeof token !== "string") return null
  try {
    const payload = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")
    return JSON.parse(atob(payload.padEnd(Math.ceil(payload.length / 4) * 4, "=")))
  } catch {
    return null
  }
}

export function reportingExpiresSoon(token: unknown): boolean {
  const reporting = decode(token)
  if (!reporting) return true
  const embedded = decode(reporting?.idtree_token)
  const internal = embedded?.idtreeToken?.supervisorConnectedId || embedded?.idtreeToken?.supervisorId
  const expiresSoon = (claims: any) => typeof claims?.exp === "number" && claims.exp <= Date.now() / 1000 + 30
  return expiresSoon(reporting) || Boolean(internal && expiresSoon(embedded))
}
